/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ next_billing_date: NonNullable<unknown> }} Subscribed_Card_Next_Billing_TrialInputs */

const en_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In trial, next renewal date: ${i?.next_billing_date}`)
};

const ar_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`في الفترة التجريبية، تاريخ التجديد التالي: ${i?.next_billing_date}`)
};

const de_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Im Prozess, nächstes Verlängerungsdatum: ${i?.next_billing_date}`)
};

const es_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En prueba, próxima fecha de renovación: ${i?.next_billing_date}`)
};

const fr_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Période d'essai en cours, renouvellement le ${i?.next_billing_date}`)
};

const it_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In prova, prossima data di rinnovo: ${i?.next_billing_date}`)
};

const ja_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トライアル中、次回更新日：${i?.next_billing_date}`)
};

const ko_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`체험판 이용 중, 다음 갱신일: ${i?.next_billing_date}`)
};

const pt_br_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Em teste. Data da próxima renovação: ${i?.next_billing_date}`)
};

const ru_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`В пробной версии, следующая дата продления: ${i?.next_billing_date}`)
};

const th_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`อยู่ระหว่างการทดลองใช้ วันต่ออายุครั้งถัดไป: ${i?.next_billing_date}`)
};

const tr_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deneme sürümünde, bir sonraki yenileme tarihi: ${i?.next_billing_date}`)
};

const zh_cn_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`试用中，下次续费日：${i?.next_billing_date}`)
};

const zh_tw_subscribed_card_next_billing_trial = /** @type {(inputs: Subscribed_Card_Next_Billing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`試用中，下次續訂日：${i?.next_billing_date}`)
};

/**
* | output |
* | --- |
* | "In trial, next renewal date: {next_billing_date}" |
*
* @param {Subscribed_Card_Next_Billing_TrialInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscribed_card_next_billing_trial = /** @type {((inputs: Subscribed_Card_Next_Billing_TrialInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscribed_Card_Next_Billing_TrialInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscribed_card_next_billing_trial(inputs)
	if (locale === "ar") return ar_subscribed_card_next_billing_trial(inputs)
	if (locale === "de") return de_subscribed_card_next_billing_trial(inputs)
	if (locale === "es") return es_subscribed_card_next_billing_trial(inputs)
	if (locale === "fr") return fr_subscribed_card_next_billing_trial(inputs)
	if (locale === "it") return it_subscribed_card_next_billing_trial(inputs)
	if (locale === "ja") return ja_subscribed_card_next_billing_trial(inputs)
	if (locale === "ko") return ko_subscribed_card_next_billing_trial(inputs)
	if (locale === "pt_br") return pt_br_subscribed_card_next_billing_trial(inputs)
	if (locale === "ru") return ru_subscribed_card_next_billing_trial(inputs)
	if (locale === "th") return th_subscribed_card_next_billing_trial(inputs)
	if (locale === "tr") return tr_subscribed_card_next_billing_trial(inputs)
	if (locale === "zh_cn") return zh_cn_subscribed_card_next_billing_trial(inputs)
	return zh_tw_subscribed_card_next_billing_trial(inputs)
});